import React from "react";
import declineSvg from "../../../static/images/x-circle-fill.svg";
import Image from "react-bootstrap/Image";

export default function DeclinedIcon() {
  return <Image src={declineSvg} />;
}
